import { rgba } from 'polished'

const _black = '#000'
const _white = '#fff'

const gray = {
  0: '#FFFFFF',
  20: '#FDFDFD',
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EAEAEA',
  300: '#E1E1E1',
  400: '#CACACA',
  500: '#B3B3B3',
  600: '#8E8E8E',
  700: '#6E6E6E',
  800: '#4B4B4B',
  900: '#2F2F2F',
  1000: '#242424',
}

const orange = {
  brand: '#F8B800',
  50: '#FBF6E7',
  100: '#FFFBEE',
  200: '#FFF6DB',
  300: '#FFE08A',
  400: '#F6B700',
  450: '#F19F01',
  500: '#F1A001',
  '500/10': '#F1A0011A',
  600: '#DC7F12',
}

const teal = {
  100: '#F3F6EF',
  300: '#D7E8C1',
  400: '#6CB214',
  500: '#3F810B',
  600: '#0B4C00',
}

const red = {
  50: '#FEF3F2',
  100: '#F9EDED',
  150: '#FEE4E2',
  200: '#FFE2E2',
  300: '#F0BFBF',
  400: '#D64040',
  500: '#B82525',
  600: '#A11818',
}

const green = {
  100: '#F3F6EF',
  200: '#D7E8C1',
  300: '#80C069',
  400: '#6CB214',
  500: '#619C01',
  600: '#4A8020',
}

const yellow = {
  100: '#E5E5E5',
}

const blue = {
  100: '#EAF1FC',
  400: '#1434CB',
  500: '#132CA0',
  600: '#12247B',
}

const black = {
  900: '#000000',
  200: '#00000014',
}

const _selectiveYellow = '#F6B700'

const color = {
  primary: _selectiveYellow,
  text: gray[1000],
  textInverted: _white,
  layoutBg: _white,
  overlay: rgba(_black, 0.8),
  error: red[400],

  bgColor: gray[0],

  dropdownSelect: {
    bg: _white,
    bgSelected: teal[100],
    bgDisabled: gray[100],
    border: gray[400],
    borderHover: gray[600],
    placeholder: gray[600],
    text: gray[900],
    optionIcon: teal[400],
  },
}

export const colors = {
  ...color,
  gray,
  orange,
  teal,
  red,
  green,
  yellow,
  blue,
  black,
} as const
